import { breakpoints } from '@/config/breakpoints';
import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0px 24px;
  max-width: 1176px;
  margin: 0 auto;
  p,
  span {
    text-align: center;
  }

  @media screen and (max-width: ${breakpoints.lg}) {
    /* padding: 24px 0 0px;
    border-top: 1px solid #1a202f; */
    padding: 0 16px;
  }
`;

export const FrameTitle = styled.div`
  display: flex;
  flex-direction: row;
  // margin-bottom: 16px;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  @media screen and (max-width: ${breakpoints.lg}) {
    padding: 0 20px;
    flex-wrap: nowrap;
    margin: 0 0 12px;
    gap: 0px;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    flex-direction: column;
    text-align: center;
  }
`;

export const TxtTitle = styled.span`
  line-height: 120%;
  color: var(--style, #fff);
  text-align: center;
  font-size: 40px;
  font-family: 'GTWalsheimPro';
  font-weight: 700;
  letter-spacing: -0.4px;
  z-index: 9;
  @media screen and (max-width: ${breakpoints.lg}) {
    font-size: 24px;
    /* line-height: 120%; */
  }
`;

export const AppFrame = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  align-items: center;
  /* gap: 10px; */
  @media screen and (max-width: ${breakpoints.lg}) {
    flex-direction: row;
    justify-content: center;
    gap: 10px;
  }
`;

export const NameAppWrapper = styled.div`
  position: relative;
`;

export const TxtNameApp = styled.p`
  color: var(--style, #fff);
  text-align: center;
  font-size: 40px;
  font-family: 'GTWalsheimPro';
  font-weight: 700;
  letter-spacing: -0.4px;
  z-index: 9;
  margin-bottom: 0;
  position: relative;
  z-index: 2;
  padding: 0 2px;
  @media screen and (max-width: ${breakpoints.lg}) {
    font-size: 24px;
    /* margin-left: 5px; */
  }
`;

export const LineView = styled.div`
  position: absolute;
  height: 10px;
  width: 100%;
  background: #34d99f;
  bottom: 15px;
  left: 0;
  /* margin-top: -23px; */
  @media screen and (max-width: ${breakpoints.lg}) {
    /* margin-left: -135px; */
    bottom: 8px;
    height: 4px;
    /* width: 138px; */
    /* margin-top: 27px; */
  }
`;

export const TxtDes = styled.span`
  color: var(--text-secondary, rgba(255, 255, 255, 0.8));
  font-size: 16px;
  font-family: Inter;
  font-weight: 500;
  text-align: center;
  margin-top: 16px;
  margin-bottom: 40px;
  @media screen and (max-width: ${breakpoints.lg}) {
    font-size: 14px;
    margin-bottom: 24px;
  }
`;

export const FramePeople = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  @media screen and (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const PeopleItem = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  position: relative;
  border-radius: 10px;
  background: var(--bg-on-blue, #141420);
  border: none;
  gap: 10px;
  padding: 24px;

  color: var(--text-primary, #fff);
  /* Body/Body 1/Regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  p {
    text-align: start !important;
    margin-bottom: 0px;
  }
`;

export const AvatarImg = styled.img`
  width: 68px;
  height: 68px;
`;

export const Quote = styled.img`
  width: 24px;
  height: 24px;
`;

export const BasicInfoUser = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 9px;
`;

export const UserName = styled.p`
  color: var(--text-primary, #fff);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

export const Job = styled.p`
  color: var(--text-secondary, #d2d2d2);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
`;
